import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'src/app/kernel/tools/message/service/message.service';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/chatperk-core/services/auth.service';
import { MutationResult } from 'apollo-angular';
import { IUser } from 'src/app/chatperk-core/interfaces';
import { AuthUserModel } from 'src/app/chatperk-core/models/AuthUser.model';
import { SIDE_DIALOG_TOKEN } from 'src/app/kernel/popups/side-popup/tokens/side-dialog.token';
import { ISideDialog } from 'src/app/kernel/popups/side-popup/types/side-dialog.interface';
import { EOtpReason } from 'src/app/chatperk-core/enums';
import { catchError, finalize, map, switchMap, takeWhile, tap, timer } from 'rxjs';

@Component({
  selector: 'app-mobile-edit',
  templateUrl: './mobile-edit.component.html',
  styleUrls: ['./mobile-edit.component.scss'],
})
export class MobileEditComponent implements OnInit {
  routeName!: string;
  formControl!: FormControl;
  otpControl = new FormControl<string | null>(null);

  @ViewChild(SIDE_DIALOG_TOKEN) sideDialog?: ISideDialog
  msg = this.translateService.instant('errors.notAuthorized');
  isVerifyView = false;
  disabled = false;
  resendLoading = false;
  resendLabel = this.translateService.instant('mobileSide.resendTheCode');
  verifyLoading = false;
  user = this.authService.getUser();

  constructor(
    private authService: AuthService,
    private translateService: TranslateService,
    private messageService: MessageService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.formControl = new FormControl({value:this.authService.getUser()?.mobile,disabled:false});
    this.routeName = '/account';
  }

  updateMobileNumber() {
    if (!this.formControl.valid) {
      return this.formControl.markAllAsTouched();
    }
    if (this.authService.getUser()?.mobile === this.formControl.value) {
      return this.goToViewPage();
    }
    this.authService
      .updateMobile(this.formControl.value)
      .subscribe({
        next: this.handleChangeMobileResponse.bind(this),
      });
  }

  handleResolverError(error: any) {
    const msg = this.translateService.instant('errors.something_went_wrong');
    const summary = this.translateService.instant('errors.summary');
  }

  handleChangeMobileResponse({ data }: MutationResult<any>) {
    this.messageService.success('The verification OTP has been sent successfully!', 'Done');
    this.isVerifyView = true;
  }

  resendOtp() {
    console.log('resendOtp');
    this.resendLoading = true;
    
    // Call authService to resend OTP
    this.authService.resendOtp(EOtpReason.VerifyMobile).pipe(
      tap(() => {        
        this.disabled = true;
        this.resendLoading = false;
        // Initialize the resend label
        this.resendLabel = this.translateService.instant('mobileSide.resendTheCode') + `(0:10)`;
        console.log(this.resendLabel);
        // Show success message
        this.messageService.success('The verification OTP has been sent successfully!', 'Done');
      }),
      switchMap(() => {
        return timer(0, 1000).pipe(
          map(i => 60  - i), 
          takeWhile(val => val >= 0, true),
          tap(count => {
            const minutes = Math.floor(count / 60);
            const seconds = count % 60;
            this.resendLabel = this.translateService.instant('mobileSide.resendTheCode') + `(${minutes}:${seconds < 10 ? '0' + seconds : seconds})`;
          }),
          finalize(() => {            
            // Reset label and enable the button after the countdown finishes
            this.resendLabel = this.translateService.instant('mobileSide.resendTheCode');
            this.disabled = false;
          })
        );
      }),
      catchError((error) => {
        // Handle the error case here, showing an error message
        this.resendLoading = false;
        this.messageService.error('Failed to resend the OTP, please try again.', 'Error');
        return [];
      })
    ).subscribe();
  }

  verifyOtp() {
    if(this.otpControl.invalid) return;
    this.verifyLoading = true;
    return this.authService.verifyContactMethod(this.otpControl.value!).pipe(
      tap(({data}) => this.handleSuccessResponse(data?.verifyContactMethod))
    )
    .pipe(finalize(() => this.verifyLoading = false))
    .subscribe({
      next: () => {
        this.sideDialog?.hideSidebar()
      },
    });
  }

  handleSuccessResponse(data?: IUser) {
    this.authService.updateUser(data!);
    this.messageService.success('The Mobile changed successfully!', 'Done');
    this.router.navigateByUrl(this.routeName).then(() => {
      window.location.reload();
  });
  }

  goToViewPage() {
    this.router.navigateByUrl(this.routeName);
  }
}
